<template>
  <div class="dealWant">
    <h2 class="normal">完成评测</h2>
    <div v-for="(item, index) in finishList" :key="item.id" class="oneWant">
      <div class="normal">剩余：{{item.rest}}</div>
      <div class="normal">
        评测楼盘:
        <span v-if="item.real_estate_name">{{item.real_estate_name}}</span>
        <span v-else>{{item.estate_id}}</span>
        <el-tag type="warning" v-if="!item.real_estate_name">没有此楼盘</el-tag>
        <el-button @click="finishWant(index)" type="primary" v-if="item.real_estate_name">已评测</el-button>
      </div>
      <div class="normal">
        评测类型:
        <span>{{item.type}}</span>
        <el-tag type="warning" v-if="item.ourGay">自己人</el-tag>
      </div>
      <div class="normal">联系：{{item.phone}}</div>
      <div class="normal">
        <div>评测内容:{{item.content.words}}</div>
        <div v-if="item.type === '日照'" class="normal">
          <img :src="item.content.sunImg.replace('_mini.jpg','')" preview="7" v-if="item.content.sunImg">
          <span v-else>无图片</span>
        </div>
        <div v-else class="apart">
          <div class="imageBox">
            <div v-for="(obj,index) in item.content.images" :key="index" class="imageItem">
              <span>编号：{{obj.imgName2}}</span>
              <span>面积：{{obj.imgName1}}</span>
              <img :src="obj.img.replace('_mini.jpg','')" preview="6" :preview-text="obj.imgName2">
              <el-button type="primary" @click="chooseApart(item.estate_id, obj)">选择</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="item.type === '日照' && item.base">
        <el-select v-model="item.result" multiple filterable default-first-option size='mini'>
          <el-option v-for="build in item.base" :key="build.name" :label="build.name" :value="build.name">
          </el-option>
        </el-select>
      </div>
      <div v-if="item.type === '户型' && item.base">
        <el-select v-model="item.result" multiple filterable default-first-option size='mini'>
          <el-option v-for="apart in item.base" :key="apart.imgName2" :label="apart.imgName2" :value="apart.imgName2">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="white"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        finishList: [],
        checkList: [],
      }
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {
      init() {
        let that = this;
        that.getFinishWant();
      },

      getCheckWant() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getCheckWant').then(function (res) {
          console.log('get want back', res)
          let checkList = res.data.data;
          that.checkList = checkList;
          checkList.forEach(x => {
            x.content = JSON.parse(x.content);
          })
          that.$previewRefresh();
        }).catch(function (res) {
          console.log('get want fail', res);
        })
      },
      getFinishWant() {
        let that = this;
        that.$axios.get(that.$url_prefix + 'getFinishWant').then(function (res) {
          console.log('get want back', res);
          let finishList = res.data.data;
          finishList.forEach(x => {
            let day = 24 * 60 * 60 * 1000;
            let hour = 60 * 60 * 1000;
            x.content = JSON.parse(x.content);
            let fast = parseInt(x.helpUsers.length / 2);
            if (fast > 5) {
              fast = 5;
            }
            x.limitTime = new Date(x.startTime).getTime() +
              (7 - fast) * day;
            let rest = x.limitTime - new Date().getTime();
            x.rest = parseInt(rest / day) + '天' + ((rest % day) / hour).toFixed(1) + '时';

          })
          finishList.sort((a, b) => a.limitTime - b.limitTime);
          that.finishList = finishList;
          that.$previewRefresh();
        }).catch(function (res) {
          console.log('get want fail', res);
        })
      },

      approveWant(index, result) {
        let that = this;
        let target = that.checkList[index];
        if (!target) {
          return;
        }
        if (result === '审核失败' && !target.note) {
          that.$message.error('填写未通过原因')
          return;
        }
        let tip = `确定${result}吗？`;
        if (!target.real_estate_name && result === '审核通过') {
          tip = `需新建楼盘, 确定审核通过吗？`;
        }
        that.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = {
            want_id: target.id,
            result: result, // 审核通过, 审核失败
            estate: target.real_estate_name,
            note: target.note
          }
          that.$axios.post(that.$url_prefix + 'approveWant', param).then(function (res) {
            console.log('back', res);
            that.init();
          }).catch(function (res) {
            console.log('err', res);
          })
        }).catch(() => {
          console.log('取消')
        });
      },

      finishWant(index) {
        let that = this;
        let target = that.finishList[index];
        if (!target) {
          return;
        }
        if (!target.result || target.result.length === 0) {
          that.$message.error('请选择这次评测的内容');
          return;
        }
        console.log(target.result);
        let tip = '确定已完成此评测吗？';
        that.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = {
            want_id: target.id,
            result: target.result
          }
          that.$axios.post(that.$url_prefix + 'finishWant', param).then(function (res) {
            console.log('back', res);
            that.init();
          }).catch(function (res) {
            console.log('err', res);
          })
        }).catch(() => {
          console.log('取消')
        });
      },

      formatDate(time) {
        let date = new Date(time);
        let y = date.getFullYear();
        let M = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let m = date.getMinutes();
        let s = date.getSeconds();
        return `${y}-${M}-${d} ${h}:${m}:${s}`
      },

      chooseApart(estate_id, apart) {
        console.log('apart', apart);
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryRealEstateApart', {
          params: {
            real_estate_id: estate_id
          }
        }).then(res => {
          console.log('query back', res);
          if (res.data.success) {
            let real = res.data.data;
            let apartment = {
              imgList: []
            }
            if (real.apartment) {
              apartment = JSON.parse(real.apartment);
            }
            let find = apartment.imgList.find(x => {
              return x.imgName2 === apart.imgName2;
            })
            if (find) {
              that.$message.error(`已存在"${apart.imgName2}"户型`);
            } else {
              delete apart.value;
              apartment.imgList.push(apart);
              let obj = {
                id: estate_id,
                apartment: JSON.stringify(apartment)
              }
              let param = {
                'db': 'WpRealEstateModel',
                'model': 'edit',
                'item': JSON.stringify(obj)
              }
              that.$axios.post(that.$url_prefix + 'updateData', param).then(res => {
                console.log('update back', res);
                that.$message({
                  type: 'success',
                  message: '操作成功'
                })
              }).catch(err => {
                console.log('update fail', err);
              })
            }
          } else {
            that.$message.error('查询失败');
          }
        }).catch(err => {
          console.log('err', err);
        })
      }

    }
  }

</script>

<style scoped>
  .dealWant {
    text-align: center;
    overflow: hidden;
  }

  .oneWant {
    margin-top: 50px;
  }

  .apart {
    display: inline-block;
  }

  .imageBox {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
  }

  .imageBox .imageItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
  }

  img {
    height: 100px;
    width: 100px;
    vertical-align: bottom;
  }

  .white {
    height: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/page/DealWant.vue